import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type FileIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

// No design-library glyph exists for a generic file yet. Uses the Lucide 'file'
// glyph on its native 24x24 grid (stroke 1.5, round caps), matching
// FileTextIcon. Replace with the library asset when one lands.
export const FileIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: FileIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='File'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M14 2v4a2 2 0 0 0 2 2h4'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
